module.exports = __webpack_public_path__ + "img/telegram_with_beak_but_circle.23bf45e6.svg";